import {css, useTheme} from '@mui/material';
import React from 'react';
import {GetStylesFunction} from 'src/js/common/types';
import {HierarchyTreeNode} from 'src/js/model/hierarchy_tree_children';

import {HierarchySyncNodeContainer} from './HierarchySyncNodeContainer';

interface OwnProps {
  hierarchyId: string | number;
  isTogglingSeparated?: boolean;
  onNodeClick?: (node: HierarchyTreeNode) => void;
  rootNode: HierarchyTreeNode;
  showRoot?: boolean;
  tabIndex?: number;
  highlightedValues?: string[];
  getOptionDisabled?: (row: any) => boolean;
}

type Props = OwnProps;

export const HierarchySyncTree: React.FC<Props> = (props) => {
  const {
    hierarchyId,
    isTogglingSeparated = false,
    onNodeClick,
    rootNode,
    showRoot = true,
    tabIndex = 0,
    highlightedValues,
    getOptionDisabled,
  } = props;

  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <ul
      data-name={'hierarchy-sync-tree--ul-role-tree'}
      role={'tree'}
      css={styles.dlHierarchySyncTree}
    >
      <HierarchySyncNodeContainer
        hierarchyId={hierarchyId}
        isTogglingSeparated={isTogglingSeparated}
        node={rootNode}
        onNodeClick={onNodeClick}
        level={1}
        showRoot={showRoot}
        tabIndex={tabIndex}
        highlightedValues={highlightedValues}
        getOptionDisabled={getOptionDisabled}
      />
    </ul>
  );
};

HierarchySyncTree.displayName = 'HierarchySyncTree';

const getStyles: GetStylesFunction = (options) => ({
  dlHierarchySyncTree: css`
    width: 100%;
    padding: 0;
  `,
});
